$(window).on("load", function() { 
  function getCookie(name) {
      let cookie = {};
      document.cookie.split(';').forEach(function(el) {
          let [k, v] = el.split('=');
          cookie[k.trim()] = v;
      });
      return cookie[name];
  }

  var fbp = getCookie('_fbp');
  var fbl = getCookie('fbl');
  var fbc = getCookie('_fbc');
  var shopgclid = getCookie('gclid');

  var msclkid;
  if (getCookie('_uetmsclkid') && getCookie('_uetmsclkid').startsWith('_uet')) {
      msclkid = getCookie('_uetmsclkid').slice(4);
  } else {
      msclkid = getCookie('_uetmsclkid');
  }

  var utm_array = [fbp, fbl, fbc, shopgclid, msclkid];
  utm_array.forEach((data) => {
      if (data !== undefined && document.getElementById(data) !== null) {
          document.getElementById(data).value = data;
          // console.log(data);
      }
  });

  // Set form fields directly
  if (document.getElementById("fbp") !== null) document.getElementById("fbp").value = fbp;
  if (document.getElementById("fbl") !== null) document.getElementById("fbl").value = fbl;
  if (document.getElementById("fbc") !== null) document.getElementById("fbc").value = fbc;
  if (document.getElementById("shopgclid") !== null) document.getElementById("shopgclid").value = shopgclid;
  if (document.getElementById("msclkid") !== null) document.getElementById("msclkid").value = msclkid;
  if (document.getElementById("Form_Url") !== null) document.getElementById("Form_Url").value = window.location.href;

  var attributes = {
      'fbp': fbp,
      'fbl': fbl,
      'fbc': fbc,
      'shopgclid': shopgclid,
      'msclkid': msclkid
  };

  for (var key in attributes) {
      if (attributes[key] === undefined || attributes[key] === null) {
          delete attributes[key];
      }
  }

  $.post('/cart.js', {
      attributes
  }).done(function () {
      // console.log(attributes);
  });
});
